import React from 'react';
import { Link } from 'react-router-dom';

import Footer from './Footer';

export default function Result({
  image1,
  image2,
  image3,
  image4,
  title,
  subtitle,
  nextTitle,
  nextLi1,
  nextLi2,
  nextLi3,
  setResult,
}) {
  return (
    <>
      <div className='result-container content-container'>
        <div className='result-btn-img-wrapper'>
          <Link
            to='/'
            style={{ textDecoration: 'none' }}
            onClick={setResult(0)}
          >
            <button>Back to start</button>
          </Link>
          <img
            src='/images/Horizontal-logo-Wmargin.png'
            className='logo result-logo'
            alt='company logo'
          />
        </div>

        <h1>
          You’re Here: <span>{title}</span>
        </h1>
        <p className='page-subtitle'>{subtitle}</p>
        <div className='result-graph-wrapper'>
          <p>
            <span>IRR and</span>
            <span> Transactions</span>
          </p>
          <img
            src='/images/result-arrow.png'
            alt='arrow'
            className='result-arrow'
          />
          <img src={image1} alt='icon' className='result-icon' />
          <img src={image2} alt='icon' className='tech-icon' />
          <img src={image3} alt='icon' className='strategic-icon' />
          <img src={image4} alt='icon' className='proprietary-icon' />
          <div className='result-graph'></div>
        </div>
        <div className='result-next-wrapper'>
          <div className='result-next'>
            <div className='result-next-left'>
              <h3 className='result-next-title'>
                What's next: <span>{nextTitle}</span>
              </h3>
              <ul>
                <li>{nextLi1}</li>
                <li>{nextLi2}</li>
                <li>{nextLi3}</li>
              </ul>
            </div>
            <div className='result-next-right'>
              <p className='result-next-subtitle'>Here's How!</p>
              <p>
                Download our free guide to learn how to build a proprietary
                dealmaking advantage using the latest data and technology.
              </p>
              <a
                href='https://live.sourcescrub.com/guide/maturity-model-guide'
                className='result-download-btn'
                id='download-guide'
              >
                Download guide <img src='/images/arrow.png' alt='arrow-icon' />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
